import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { JaladorService } from '../../../_core/services/jalador.service';

@Component({
  selector: 'm-add-edit-jalador-dialog',
  templateUrl: './add-edit-jalador-dialog.component.html',
  styleUrls: ['./add-edit-jalador-dialog.component.scss']
})
export class AddEditJaladorDialogComponent implements OnInit {
  viewLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddEditJaladorDialogComponent>,
    private _formBuilder: FormBuilder,
    public toastr: ToastrManager,
		@Inject(MAT_DIALOG_DATA) public data: any,
    private jaladorService: JaladorService
  ) { }

  ngOnInit() {
    this.create_form();

    if(this.data.item != null){
      this.formMACRO.controls.NombreJalador.setValue(this.data.item.JaladorNombre);
      this.formMACRO.controls.DNI.setValue(this.data.item.JaladorDNI);
      this.formMACRO.controls.Telefono1.setValue(this.data.item.Telefono1);
      this.formMACRO.controls.Telefono2.setValue(this.data.item.Telefono2);
      this.formMACRO.controls.Localidad.setValue(this.data.item.Localidad);
      this.formMACRO.controls.Direccion.setValue(this.data.item.Direccion);
    }
  }

  formMACRO: FormGroup;
  create_form(){
    this.formMACRO = this._formBuilder.group({
      NombreJalador: [null, Validators.required],
      DNI: [null, Validators.required],
      Telefono1: [null, Validators.required],
      Telefono2: [null/*, Validators.required*/],
      Localidad: [null, Validators.required],
      Direccion: [null, Validators.required],
    });
  }

  saveUpdate() {
    const _controls = this.formMACRO.controls; 
    if (this.formMACRO.invalid) {
      Object.keys(_controls).forEach(controlName =>
        _controls[controlName].markAsTouched()
      );
      this.toastr.warningToastr('Ingrese los campos obligatorios.', 'Advertencia!', {
        toastTimeout: 2000,
        showCloseButton: true,
        animate: 'fade',
        progressBar: true
      });
    } else {
      this.viewLoading = true;
        let model = {
          prmintJalador: this.data.item != null ? this.data.item.Jalador : 0,
          prmstrNombre: _controls.NombreJalador.value,
          prmstrDNI: _controls.DNI.value,
          prmstrTelefono1: _controls.Telefono1.value,
          prmstrTelefono2: _controls.Telefono2.value,
          prmstrLocalidad: _controls.Localidad.value,
          prmstrDireccion: _controls.Direccion.value,
        };
        
        this.jaladorService.SaveUpdateJalador(model).subscribe(
          (data: any) => {
            if(data[0].Ok){
              this.toastr.successToastr(data[0].Message, 'Éxito!', {
                toastTimeout: 2000,
                showCloseButton: true,
                animate: 'fade',
                progressBar: true
              });
            }else{
              this.toastr.warningToastr(data[0].Message, 'Advertencia!', {
                toastTimeout: 2000,
                showCloseButton: true,
                animate: 'fade',
                progressBar: true
              });
            }
            this.viewLoading = false;
            this.dialogRef.close(true);
          }, ( errorServicio ) => {
            this.toastr.errorToastr(errorServicio.message, 'Error!', {
              toastTimeout: 2000,
              showCloseButton: true,
              animate: 'fade',
              progressBar: true
            });
            this.viewLoading = false;
            console.log(errorServicio);
          }
        );
    }
  }

  onNoClick(): void {
		this.dialogRef.close();
  }

  onYesClick() {
    this.viewLoading = true;
    this.dialogRef.close(true);
  }
}
